export const StylesDocsLayout = (theme) => ({
  nav: {
    width: 320,
    space: theme.space.base,
  },
  search: {
    maxWidth: 600,
  },
  header: {
    height: theme.height.base,
  },
})
